export function messagesBasePath(deskRole, { office = false } = {}) {
  if (deskRole === "admin") return office ? "/admin/office" : "/admin/messages";
  if (deskRole === "broker") return office ? "/broker/office" : "/broker/messages";
  if (deskRole === "agent") return office ? "/agent/office" : "/agent/messages";
  return "/client/messages";
}

export function messagesPath(deskRole, { archive = false, threadId, transactionId, office = false } = {}) {
  const path = archive ? `${messagesBasePath(deskRole, { office })}/archive` : messagesBasePath(deskRole, { office });
  const params = new URLSearchParams();
  if (threadId) params.set("thread", threadId);
  else if (transactionId) params.set("tx", transactionId);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function deskRoleFromPath(pathname, sessionRole) {
  if (pathname.startsWith("/admin")) return "admin";
  if (pathname.startsWith("/broker")) return "broker";
  if (pathname.startsWith("/agent")) return "agent";
  if (pathname.startsWith("/client")) return "client";
  if (sessionRole === "admin") return "admin";
  if (sessionRole === "broker") return "broker";
  if (sessionRole === "agent") return "agent";
  return "client";
}

export function isOfficeMessagesPath(pathname = "") {
  return String(pathname).includes("/office");
}
